import { checkLatLngIsWithinDistance } from '@src/utils/geo/check-lat-lng-within-distance'
import { checkLatLngIsWithinPerimeter } from '@src/utils/geo/check-lat-lng-within-perimeter'
import { getDistanceFromLatLngToPerimeter } from '@src/utils/geo/get-lat-lng-distance-from-perimeter'

interface Coordinates {
    lat: number;
    lng: number;
}
interface Perimeter {
    lat: number;
    lng: number;
}


interface LocationGeo {
    coordinates?: Coordinates;
    gpsDriftMeters?: number;
    perimeter?: Perimeter[];
}
/**
 * Checks if a latLng is within a locationGeo coords or perimeter.
 *
 * This will take into account the Location Geo drift and the latLng accuracy.
 *
 * @param latLng
 * @param locationGeo
 */
export function checkLatLngWithinLocationGeo(
  latLng: {
    accuracy: number
    lat: number
    lng: number
  },
  locationGeo: LocationGeo,
): boolean {
  if (locationGeo.perimeter) {
    const insidePerimeter = checkLatLngIsWithinPerimeter(
      {
        lat: latLng.lat,
        lng: latLng.lng,
      },
      locationGeo.perimeter,
    )

    if (insidePerimeter) {
      return true
    }

    const distanceToPerimeter = getDistanceFromLatLngToPerimeter(
      {
        lat: latLng.lat,
        lng: latLng.lng,
      },
      locationGeo.perimeter,
    )

    const drift = locationGeo.gpsDriftMeters || 0

    return distanceToPerimeter - latLng.accuracy < drift
  }

  if (locationGeo.coordinates) {
    return checkLatLngIsWithinDistance(
      {
        lat: latLng.lat,
        lng: latLng.lng,
      },
      locationGeo.coordinates,
      //   when checking against the center of the location we add 200 meter default drift if none is provided
      locationGeo.gpsDriftMeters || 200,
    )
  }

  console.warn('checkLatLngWithinLocationGeo() no locationGeo provided')

  return false
}
